var $ = require('jquery');

var Modal = function Modal() {
	var $triggers = $('[data-modal]');
	var $modal = $('.modal');

	this.padDate = function padDate(date) {
		date = date.toString();

		if(date.length === 1 && date[0] !== '0') {
			var arr = date.split();
			arr.unshift('0');
			
			return arr.join('');
		} else {
			return date;
		}
	}

	this.addMinDate = function addMinDate($element) {
		var date = new Date(this.getFirstValidDate());
		var month = this.padDate(date.getMonth() + 1);
		var day = this.padDate(date.getDate());

		var finalDate = date.getFullYear() + '-' + month + '-' + day;
		$element.attr('min', finalDate)[0].value = finalDate;
	}

	this.getFirstValidDate = function getFirstValidDate() {
		var today = new Date('2016-1-17');

		var day = today.getUTCDay();

		if(day === 0) day = (today.getDate() + 1);
		if(day === 6) day = (today.getDate() + 2);

		return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + day;
	}

	this.close = function close() {
		$modal.hide();
		$('html, body').css({
			'overflow': 'auto',
			'height': 'auto'
		});
	}

	this.invalidateWeekends = function invalidateWeekends($element) {
		var self = this;
		$element.on('change', function(e) {
			var day = new Date(e.target.value).getUTCDay();

			if(day === 0 || day === 6) {
				var date = new Date(self.getFirstValidDate());
				var month = self.padDate(date.getMonth() + 1);
				var day = self.padDate(date.getDate());

				var finalDate = date.getFullYear() + '-' + month + '-' + day;
				$element[0].value = finalDate
			}
		});
	}

	var self = this;

	if($triggers.length && $modal.length) {
		$('body').click(function(e) {
			if(e.target !== $modal[0]) {
				if($modal.is(':visible') && ($(e.target).parents('.modal').length < 1)) {
					self.close();
				}
			}
		});

		$modal.find('.close').click(function() { self.close(); });

		$triggers.click(function(e) {
			e.preventDefault();
			e.stopPropagation();
			var $this = $(this);

			var $type = $modal.find('[data-type="' + $this.attr('data-modal') + '"]');

			$type.show().siblings().hide();
			$modal.show();

			$('html, body').css({
				overflow: 'hidden'
			});
			
			if($this.attr('data-modal-workspace')) {
				$type.find('input[type="checkbox"][value="' + $this.attr('data-modal-workspace') + '"]').prop('checked', true);
			}
		});

		var $date = $modal.find('input[type="date"]');
		this.addMinDate($date);
		this.invalidateWeekends($date);
	}

	$modal.find('input[type="checkbox"]').on('click', function() {
		var $this = $(this);
		var $parents = $this.parents('.right, .left');
		var full = ($this.parents('.option').attr('data-full') === 'yes');

		if($this.prop('checked') && full) {
			$parents.append('<span data-for="' + $this.attr('value') + '">' + $this.siblings('.name').find('span').text() + ' is full, however we will add you to the waiting list.</span>');	
		} else if(full) {
			$parents.find('span[data-for="' + $this.attr('value') + '"]').remove();
		}
	});
}

module.exports = Modal;